document.addEventListener("DOMContentLoaded", function () {
    let loading = false;
    let nextPageUrl = document.querySelector('.pagination__next, .next').href;

    if (!nextPageUrl) return;

    window.addEventListener('scroll', function () {
        if (loading) return;

        if (window.innerHeight + window.scrollY >= document.body.offsetHeight - 400) {
            loading = true;

            fetch(nextPageUrl)
                .then(response => response.text())
                .then(data => {
                    const parser = new DOMParser();
                    const newDoc = parser.parseFromString(data, "text/html");

                    // products container
                    const newProducts = newDoc.querySelectorAll('.product-grid, .collection-grid, .grid--collection .grid__item');

                    newProducts.forEach(item => {
                        document.querySelector('.product-grid, .collection-grid, .grid--collection')
                            .appendChild(item);
                    });

                    // update next page URL
                    const newNext = newDoc.querySelector('.pagination__next, .next');
                    if (newNext) {
                        nextPageUrl = newNext.href;
                        loading = false;
                    } else {
                        nextPageUrl = null; // no more pages
                    }
                });
        }
    });
});
